'use client';
import {
  PlaceholderConfig,
  PlaceholderContextValues
} from '@spa/lib/react/context/PlaceholderContext';
import { ComponentType } from 'react';
import { HeightSinceWidth } from '../../placeholder/placeholder.component';
import { Props } from './one-page-checkout.component';
import dynamic from 'next/dynamic';

const DynamicOnePageCheckoutComponent: ComponentType<Props> = dynamic(
  () => import('./one-page-checkout.component')
);

export default DynamicOnePageCheckoutComponent;

export function calculateOnePageCheckoutPlaceholderConfig(
  _: Props,
  contextValues: PlaceholderContextValues
): PlaceholderConfig {
  const cart = contextValues.cart;
  let heightSinceWidth: HeightSinceWidth;
  if (cart === null || cart.entries.length > 3) {
    heightSinceWidth = [
      { sinceWidth: 0, height: 610 },
      { sinceWidth: 466, height: 932 },
      { sinceWidth: 768, height: 688 },
      { sinceWidth: 1024, height: 1071 }
    ];
  } else {
    heightSinceWidth = [
      { sinceWidth: 0, height: 610 },
      { sinceWidth: 466, height: 890 },
      { sinceWidth: 1024, height: 642 }
    ];
  }
  return {
    heightSinceWidth
  };
}
